import { toast } from "react-hot-toast";
import { Get } from "../../../Request";

export const CostRender = new Intl.NumberFormat("en-US");

export const sepJustMoney = data => {
    if (data == "" || data == null) {
        return data;
    }
    let newMoney = data;
    if (typeof data != "number") {
        newMoney = data.replace(/\D/g, '');
    }
    return CostRender.format(newMoney);

};

export const addRemoveFavarit = async (id, act) => {
    const data = await Get({ url: "/user/favs_add", data: { item_id: id, action: act }, addRes: true });
    // let fList = JSON.parse(localStorage.getItem("favList")) || [];
    if (data.status == "Success") {
        if (act == "add") {
            toast.success('با موفقیت به علاقه‌مندی ها اضافه شد')
        }
        else {
            toast.success('با موفقیت از علاقه‌مندی ها حذف شد')
        }
        //     if (act == "add") {
        //         fList.push(id);
        //         localStorage.setItem("favList", JSON.stringify(fList))
        //     }
        //     else {
        //         fList = fList.filter(item => {
        //             return item != id;
        //         })
        //         localStorage.setItem("favList", JSON.stringify(fList))
        //     }
        return true
    }
}


// export const getFavorite = async (id) => {
//     let fList = JSON.parse(localStorage.getItem("favList")) || [];
//     let inList = false;
//     fList.filter(item => {
//         if (item == id)
//             inList = true;
//     })
//     return inList
// }
